import React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MatchList from "./MatchList/MatchList";
import "./styles/TopBlocks.css";
import { mapMatchIds } from "./helpers/mapMatchIds";
import { getReservedMatches } from "./helpers/getReservedMatches";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const ReserveMatches = () => {
    const leagueState = useSelector((state) => state.leagueReducer.data);
    const matchesState = useSelector((state) => state.matchesReducer.data);
    const { t } = useTranslation();

    const matchIds =
        leagueState !== null ? mapMatchIds(leagueState?.matchDays) : [];

    return (
        <div className="reserve-matches-wrap">
            <Accordion defaultExpanded>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Typography sx={{ color: "#FF0014" }}>
                        {t("gamedays.reserved_matches.title")}
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <MatchList
                        matches={getReservedMatches(matchIds, matchesState)}
                        withForm={false}
                    />
                </AccordionDetails>
            </Accordion>
        </div>
    );
};

export default ReserveMatches;
